<form class="wrapper" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
  <div class="login-form">
    <h1>{{ 'login' | translate }}</h1>

    @if (error()) {
      <div class="error-message">
        <mat-icon fontSet="material-symbols-rounded">error</mat-icon>
        <span>{{ error() }}</span>
      </div>
    }

    @if (loginMode() === 'unknown' && loginTypeLoading()) {
      <div class="user-welcome shimmer">
        <div class="welcome-label skeleton-text"></div>
        <div class="email-chip skeleton-chip"></div>
      </div>
    }

    <div class="form-content-wrapper">
      @if (loginMode() === 'unknown') {
        <mat-form-field>
          <mat-icon matPrefix fontSet="material-symbols-rounded">home</mat-icon>
          <mat-label>{{ 'email' | translate }}</mat-label>
          <input matInput type="text" autocomplete="username" formControlName="email" />
          @if (loginForm.get('email')?.invalid && loginForm.get('email')?.touched) {
            <mat-error>{{ 'invalidEmail' | translate }}</mat-error>
          }
        </mat-form-field>

        <button mat-flat-button type="submit" [disabled]="loginTypeLoading() || !loginForm.get('email')?.value || loginForm.get('email')?.invalid">
          @if (loginTypeLoading()) {
            <mat-spinner diameter="20"></mat-spinner>
          } @else {
            {{ 'next' | translate }}
          }
        </button>
      } @else {
        <!-- Identity Anchor -->
        <div class="user-welcome">
          <span class="welcome-label">{{ 'signingInAs' | translate }}</span>
          <div class="email-chip">
            <mat-icon fontSet="material-symbols-rounded" class="chip-icon">alternate_email</mat-icon>
            <span class="email-value">{{ loginForm.get('email')?.value }}</span>
            <button mat-icon-button type="button" (click)="resetLoginType()" class="small-icon-button">
              <mat-icon fontSet="material-symbols-rounded">edit</mat-icon>
            </button>
          </div>
        </div>

        @if (loginMode() === 'password') {
          <!-- Password login mode -->
          <input type="hidden" autocomplete="username" [value]="$safeNavigationMigration(loginForm.get('email')?.value)" />
          <mat-form-field>
            <mat-icon matPrefix fontSet="material-symbols-rounded">key</mat-icon>
            <mat-label>{{ 'password' | translate }}</mat-label>
            <input
              #passwordInput
              matInput
              autocomplete="current-password"
              [type]="hide() ? 'password' : 'text'"
              formControlName="password"
            />
            <button
              mat-icon-button
              matSuffix
              type="button"
              (click)="clickEvent($event)"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hide()"
            >
              <mat-icon fontSet="material-symbols-rounded">
                {{ hide() ? 'visibility_off' : 'visibility' }}
              </mat-icon>
            </button>
          </mat-form-field>
          <div class="forgot-password-container">
            <button mat-button type="button" class="forgot-password-btn" (click)="switchToOtpLogin()">
              {{ 'loginWithOtp' | translate }}
            </button>
          </div>
          <button mat-flat-button type="submit">
            {{ 'login' | translate }}
          </button>
        } @else if (loginMode() === 'otp') {
          <!-- OTP login mode -->
          @if (!showOtpInput()) {
            <button
              mat-flat-button
              type="button"
              [disabled]="!loginForm.get('email')?.value || otpSending()"
              (click)="sendLoginOtp()"
            >
              @if (otpSending()) {
                <mat-spinner diameter="20"></mat-spinner>
              } @else {
                {{ 'sendLoginCode' | translate }}
              }
            </button>
          } @else {
            @if (detectedUserType() === null) {
              <div class="new-user-inline-notice">
                <mat-icon fontSet="material-symbols-rounded">info</mat-icon>
                <span>{{ 'newAccountNotice' | translate }}</span>
              </div>
            }
            <p class="otp-sent-message">
              {{ 'otpSentMessage' | translate: {email: $safeNavigationMigration(loginForm.get('email')?.value)} }}
            </p>
            <otg-otp-input
              #otpInput
              [loading]="otpVerifying()"
              [error]="error()"
              [resendCountdown]="otpResendCountdown()"
              (codeCompleted)="verifyLoginOtp($event)"
              (resendRequested)="sendLoginOtp()"
            ></otg-otp-input>
          }
          @if (detectedUserType() === UserType.Otg) {
            <div class="switch-login-container">
              <button mat-button type="button" class="switch-login-btn" (click)="switchToPasswordLogin()">
                {{ 'loginWithPassword' | translate }}
              </button>
            </div>
          }
        }
      }
    </div>

    <p class="register-link">
      {{ 'createAccountPrefixText' | translate }}
      <a routerLink="/register">{{ 'register' | translate }}</a>
    </p>
  </div>
  @if (logoPath$ | async; as logoPath) {
    <img [src]="logoPath" width="50" alt="Login organisationlogo" class="logo" />
  } @else {
    <img src="assets/logo_light.png" alt="Login organisationlogo" width="100" priority />
  }
</form>
